<div class="w-full">
  <ng-container *ngIf="options$ | async as options">
    <jml-lib-dropdown-cell-new
      [header]="field.header"
      (completeCellEdit)="emitComplete($event)"
      [fieldName]="field.field"
      [value]="selectedCatalogueEntry"
      [editable]="editable"
      [options]="options"
      [tableReference]="tableReference"
      [showLabel]="field?.showLabel ?? true"
      [showIcon]="field?.showIcon ?? true"
      [showTooltip]="field?.showTooltip ?? true"
      [customEdit]="customEdit"
      (onCustomEdit)="emitOnCustomEdit()"
    >
    </jml-lib-dropdown-cell-new>
  </ng-container>
</div>
